export default __webpack_public_path__ + "static/firestick-football-e7f61ad31e4ba99edc3d9da2c07bc00c.jpg";